import { ReactNode, useEffect } from 'react';
import { createUseStyles } from 'react-jss';
import { Theme, theme as defaultTheme } from '@app/theme';
import BikeBroken from '@app/illu/Image/BikeBroken.svg';
import { useTranslation } from 'react-i18next';
import { Button } from '../Buttons/Button';
import { useTrack } from '@app/analytics';
import { useIsClient } from '@app/api';

const useStyles = createUseStyles((theme: Theme = defaultTheme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.marginBase * 12,
    marginBottom: theme.marginBase * 12,
  },
  content: {
    textAlign: 'center',
    maxWidth: theme.maxContentWidth.reduced,
  },
  title: {
    ...theme.fonts.h3,
    textAlign: 'center',
    marginTop: theme.marginBase * 8,
  },
  subtitle: {
    marginTop: theme.marginBase * 3,
  },
  button: {
    marginTop: theme.marginBase * 3,
  },
  illustration: {
    maxWidth: '100%',
  },
}));

interface Props {
  title?: ReactNode;
  text?: ReactNode;
  button?: ReactNode;
  to?: string;
}

export const NotFound = (props: Props) => {
  const classes = useStyles();
  const { t } = useTranslation('common');

  const isClient = useIsClient();
  const track = useTrack();

  useEffect(() => {
    track('Page not found', {
      nonInteraction: true,
    });
  }, []);

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <img src={BikeBroken} alt="404" className={classes.illustration} />
        <h1 className={classes.title}>
          {props.title ? props.title : t('notFound.title')}
        </h1>
        <p className={classes.subtitle}>
          {props.text ? props.text : t('notFound.subtitle')}
        </p>
        {(props.button || isClient) && (
          <Button className={classes.button} to={props.to || '/'}>
            {props.button ? props.button : t('notFound.button')}
          </Button>
        )}
      </div>
    </div>
  );
};
